import React, { useState, useEffect, useRef } from "react";
import {
  AutoComplete,
  Button,
  Form,
  Input,
  Typography,
  InputNumber,
  Select,
} from "antd";
import "./styles.css";
import {
  getPersonalDetailsLocation,
  updateCompanyProfileDetails,
  resetCompanyProfileDetails,
  fetchUserProfile,
  getCompanyProfileDetails,
} from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import history from "../../../routes/history";
import TopAlert from "../../../components/TopNotification/TopAlert";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../../shared/helpers";
import { disable } from "workbox-navigation-preload";
import { left } from "@antv/g2plot/lib/plots/sankey/sankey";
import { NumericInput } from "./NumericInput";
import { getCountryPhoneCode, getFullStateName } from "./helper";
import { debounce } from "../../../shared/helpers";
import { Option } from "antd/lib/mentions";


const MyPersonalDetails = (props) => {
  const buttonText = props.buttonText;
  const { Text } = Typography;
  const [resp, setResp] = useState(null);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authReducer.user.authToken);
  const finishProfile = getCookie("finishProfile");
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));
  const [buttonTxt, setButtonTxt] = useState(finishProfile ? "Edit" : "Save");
  const path = useLocation();
  const [location, setLocation] = useState([]);
  const [navigate, setNavigate] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const hasSubmitted = useRef(false);
  const [editDone, setEditDone] = useState(false);
  const [buttonCancelTxt, setButtonCancelTxt] = useState("Cancel");
  const [flag, setFlag] = useState(false);
  const [onlyCancel, setOnlyCancel] = useState(false);
  const [form] = Form.useForm();
  const cpResp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );
  const profile = useSelector((state) => state.profileReducer.user);  
  const [FlagToUpdate, setFlagToUpdate] = useState(false);  
  const [customMessage, setcustomMessage] = useState(false);  
  const [errorColor, seterrorColor] = useState(false);  
  const [flagcode, setflagcode] = useState("US");  
  const [CountryCodeValue, setCountryCodeValue] = useState(
    userProfile1?.Profiles?.MobilePhone
    ? userProfile1.Profiles.MobilePhone.substring(0, userProfile1.Profiles.MobilePhone.indexOf('('))
    : cpResp?.companyProfile?.MobilePhone
    ? cpResp.companyProfile.MobilePhone.substring(0, cpResp.companyProfile.MobilePhone.indexOf('('))
    : resp?.Profiles?.MobilePhone
    ? resp.Profiles.MobilePhone.substring(0, resp.Profiles.MobilePhone.indexOf('('))
    : "1");
  const [isFormRendered, setIsFormRendered] = useState(true);

  const PhoneFormat = (val, countryCode = "") => {
    if (!val) return "";

    const digits = val.replace(/\D/g, "");

    if (countryCode && digits.startsWith(countryCode)) {
      const remainingDigits = digits.slice(countryCode.length);
      return formatNumber(remainingDigits);
    } else if (digits.length > 10) {
      const remainingDigits = digits.slice(1);
      return formatNumber(remainingDigits);
    } else {
      return digits;
    }
  };

  const formatNumber = (digits) => {
    return digits.length >= 10
      ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
      : digits;
  };
  const [MobilePhone, setPhoneNumber] = useState(
    userProfile1.Profiles?.MobilePhone
            ? PhoneFormat(userProfile1.Profiles?.MobilePhone.substring(userProfile1.Profiles?.MobilePhone?.indexOf('(')))
            : cpResp?.companyProfile?.MobilePhone
            ? PhoneFormat(cpResp?.companyProfile?.MobilePhone.substring(cpResp?.companyProfile?.MobilePhone?.indexOf('(')))
            : resp?.Profiles?.MobilePhone ?
             PhoneFormat(resp?.Profiles?.MobilePhone.substring(resp?.Profiles?.MobilePhone?.indexOf('(')))
            : ""
  );

  const defaultValues = {
      FirstName:
        userProfile1.Profiles?.FirstName &&
        userProfile1.Profiles?.LastName != null
          ? userProfile1.Profiles?.FirstName
          : cpResp?.companyProfile?.FirstName
          ? cpResp?.companyProfile?.FirstName
          : resp?.Profiles?.FirstName ?? "",
      LastName: userProfile1.Profiles?.LastName
        ? userProfile1.Profiles?.LastName
        : cpResp?.companyProfile?.LastName
        ? cpResp?.companyProfile?.LastName
        : resp?.Profiles?.LastName ?? "",
      PreferredName: userProfile1.Profiles?.PreferredName
        ? userProfile1.Profiles?.PreferredName
        : cpResp?.companyProfile?.PreferredName
        ? cpResp?.companyProfile?.PreferredName
        : resp?.Profiles?.PreferredName ?? "",
      JobTitle: userProfile1.Profiles?.JobTitle
        ? userProfile1.Profiles?.JobTitle
        : cpResp?.companyProfile?.JobTitle
        ? cpResp?.companyProfile?.JobTitle
        : resp?.Profiles?.JobTitle ?? "",
      EmailAddress: userProfile1?.EmailAddress
        ? userProfile1.EmailAddress
        : cpResp?.companyProfile?.EmailAddress
        ? cpResp?.companyProfile?.EmailAddress
        : resp?.EmailAddress ?? "",
      MobilePhone: 
      userProfile1.Profiles?.MobilePhone
              ? PhoneFormat(userProfile1.Profiles?.MobilePhone.substring(userProfile1.Profiles?.MobilePhone?.indexOf('(')))
              : cpResp?.companyProfile?.MobilePhone
              ? PhoneFormat(cpResp?.companyProfile?.MobilePhone.substring(cpResp?.companyProfile?.MobilePhone?.indexOf('(')))
              : resp?.Profiles?.MobilePhone ?
               PhoneFormat(resp?.Profiles?.MobilePhone.substring(resp?.Profiles?.MobilePhone?.indexOf('(')))
              : "",
      AddressLine1: userProfile1.Profiles?.AddressLine1
        ? userProfile1.Profiles?.AddressLine1
        : cpResp?.companyProfile?.AddressLine1
        ? cpResp?.companyProfile?.AddressLine1
        : resp?.Profiles?.AddressLine1 ?? "",
      AddressLine2: userProfile1.Profiles?.AddressLine2
        ? userProfile1.Profiles?.AddressLine2
        : cpResp?.companyProfile?.AddressLine2
        ? cpResp?.companyProfile?.AddressLine2
        : resp?.Profiles?.AddressLine2 ?? "",
      cityState: userProfile1.Profiles?.LocationWithCountry
      ?? cpResp?.companyProfile?.LocationWithCounty
      ?? userProfile1.Profiles?.Countries?.CountryName,
      ZipCode: userProfile1.Profiles?.ZipCode
        ? userProfile1.Profiles?.ZipCode
        : cpResp?.companyProfile?.ZipCode
        ? cpResp?.companyProfile?.ZipCode
        : resp?.Profiles?.ZipCode ?? "",
    }
  const FormValues = (values) => {
    const MobileNum = CountryCodeValue + values.MobilePhone.replace(/\D/g, '')
    if (!onlyCancel && buttonTxt == "Save") {
      const updatePayload = {};
      const addChangedValue = (key, value, initialValue) => {
        const isEmpty = value == null || (typeof value === "string" && value.trim() === "");

        if (!isEmpty && value !== initialValue) {
          updatePayload[key] = value;
        }
      };

      addChangedValue("AddressLine1", values.AddressLine1, defaultValues.AddressLine1);
      addChangedValue("AddressLine2", values.AddressLine2, defaultValues.AddressLine2);
      addChangedValue("AlternateEmailAddress", values.EmailAddress, defaultValues.EmailAddress);
      addChangedValue("FirstName", values.FirstName, defaultValues.FirstName);
      addChangedValue("JobTitle", values.JobTitle, defaultValues.JobTitle);
      addChangedValue("LastName", values.LastName, defaultValues.LastName);
      addChangedValue("PreferredName", values.PreferredName, defaultValues.PreferredName);
      addChangedValue("ZipCode", values.ZipCode, defaultValues.ZipCode);

      const initialMobilePhone = userProfile1?.Profiles?.MobilePhone
        ?? cpResp?.companyProfile?.MobilePhone
        ?? resp?.Profiles?.MobilePhone
        ?? "";
      if (MobileNum && MobileNum.replace(/\D/g, "") !== initialMobilePhone.replace(/\D/g, "")) {
        updatePayload.MobilePhone = MobileNum;
      }

      if (form.isFieldTouched("cityState") && locationValue) {
        updatePayload.Location = locationValue;
        if (locationValue?.LocationWithCountry) {
          updatePayload.LocationWithCountry = locationValue.LocationWithCountry;
        }
      }

      if (Object.keys(updatePayload).length === 0) {
        setButtonTxt("Edit");
        setFlag(false);
        return;
      }

      hasSubmitted.current = true;
      dispatch(
        updateCompanyProfileDetails({
          ...updatePayload,
          isProfileEdit: true
        })
      );
      return;
    } else if (onlyCancel && buttonCancelTxt == "Cancel") {
      setButtonTxt("Edit");
      setFlag(!flag);
      setEditDone(true);
      setOnlyCancel(false);      
      form.setFieldsValue(defaultValues);      
      setflagcode( userProfile1?.Profiles?.Location?.CountryName ? getFullStateName(userProfile1?.Profiles?.Location?.CountryName): "US");
      setCountryCodeValue(userProfile1?.Profiles?.Location?.CountryName ? getCountryPhoneCode(userProfile1?.Profiles?.Location?.CountryName): "1");
      setIsFormRendered(false);
      setTimeout(() => setIsFormRendered(true), 0);
    }
  };

  const flagselection = (
    <>
      <div
        className={`roleExperience-Flag-Mobile-code ${errorColor === true ? `Flag-Mobile-code-borderColor` : null
        }`}
      >
        <span>
          <img
            src={`https://www.worldatlas.com/r/w24/img/flag/${flagcode?.toLowerCase()}-flag.jpg`}
          />
        </span>
          <span style={{marginLeft: "5px"}} className="roleExperience-Mobile-code">+{CountryCodeValue}</span>
      </div>
    </>
  );

  useEffect(() => {    
    if(userProfile1?.Profiles?.Location?.CountryName) {
    setflagcode(getFullStateName(userProfile1?.Profiles?.Location?.CountryName));
    setCountryCodeValue(getCountryPhoneCode(userProfile1?.Profiles?.Location?.CountryName));
    }
  }, []);

  const getlocationData = async (value) => {
    const locationParse = JSON.parse(value);
    setLocationValue(locationParse.Location);
    setflagcode(getFullStateName(locationParse.CountryName));
    setCountryCodeValue(getCountryPhoneCode(locationParse.CountryName));
    setFlagToUpdate(true);
  };

  const [locationValue, setLocationValue] = useState(userProfile1?.Profiles?.Location 
    ? userProfile1?.Profiles?.Location
    : cpResp?.companyProfile?.Location ??"");
 
  const filters = useSelector(
    (state) => state.getPersonalDetailsLocationReducer.location
  );
  
  const loading = useSelector(
    (state) => state.getCompanyDetailsReducer.loading
  );
  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );
  useEffect(() => {
    dispatch(getPersonalDetailsLocation(locationValue ?? ''));
    
  }, []);

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
    dispatch(fetchUserProfile(token));
  }, []);
  
  useEffect(() => {
    var options = [];
    for (var i = 0; i < filters.length; i++) {
      options = [
        ...options,
        {
          value: filters[i],
        },
      ];
    }
    setLocation(filters);
  }, [filters.length]);

  const setLocationObject = (value) => {
    setLocationValue(JSON.parse(value));
  };

  useEffect(() => {
    if (success && hasSubmitted.current) {
      setButtonTxt("Edit");
      setFlag(false);
      setOnlyCancel(false);
      hasSubmitted.current = false;
      setShowHeader(true);
      setTimeout(() => {
        if (path.state?.previous === "drawer") {
          history.push("/employerdashboard");
        }
        dispatch(resetCompanyProfileDetails());
      }, 3000);
    }
  }, [success]);

  const setCityState = (e) => {
    dispatch(getPersonalDetailsLocation(e));
    var options = [];

    for (var i = 0; i < filters.length; i++) {
      options = [
        ...options,
        {
          value: filters[i].Location,
        },
      ];
    }
    // setLocation(options);
    setLocation(filters);
  };

  const [phoneCheck, setPhoneCheck] = useState(false);
  const handlePhoneInput = (txt) => {
    if (/^\d+$/.test(txt)) {
      setPhoneCheck(false);
    } else setPhoneCheck(true);
  };

  return (
    <div>
      {showHeader && (
        <>
          <TopAlert
            display={"block"}
            title={"Profile successfully updated"}
            type="success"
          />
        </>
      )}
      {history?.location?.state?.fromCompanyDetails && (
        <div className="personal-details-text">Add your details</div>
      )}
      {isFormRendered && (
      <Form
        className={buttonTxt === "Edit" ? "myProfile-personal-form-readonly" : ""}
        onFinish={FormValues}
        initialValues={defaultValues}
        layout="vertical"
        disabled={finishProfile ? !flag : flag}
      >
        <div className="myProfile-details-form">
          <strong style={{ fontSize: "16px" }}>
            First name <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            name={"FirstName"}
            rules={[
              {
                validator: (_, value) => {
                  if (!value.trim() == "") {
                    if (/^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error("Please enter valid first name")
                      );
                    }
                  } else {
                    return Promise.reject(new Error("Add your first name"));
                  }
                },
              },
            ]}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              placeholder="Add your first name..."
              type={"input"}
              onKeyDown={(e) => e.which === 32 && e.preventDefault()}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Last name <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            name={"LastName"}
            rules={[
              {
                validator: (_, value) => {
                  if (!value.trim() == "" && value.length > 0) {
                    if (/^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error("Please enter valid last name")
                      );
                    }
                  } else {
                    return Promise.reject(new Error("Add your last name"));
                  }
                },
              },
            ]}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              placeholder="Add your last name..."
              type={"input"}
              onKeyDown={(e) => e.which === 32 && e.preventDefault()}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Display name <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            name={"PreferredName"}
            rules={[
              {
                validator: (_, value) => {
                  if (!value.trim() == "") {
                    if (/^[a-zA-Z]+( [a-zA-Z]+)*$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error("Please enter valid display name")
                      );
                    }
                  } else {
                    return Promise.reject(new Error("Add the name you want displayed"));
                  }
                },
              },
            ]}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              placeholder="Add your display name..."
              type={"input"}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Job title <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            rules={[
              {
                validator: (_, value) => {
                  if (!value.trim() == "") {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("Add the title of your job"));
                  }
                },
              },
            ]}
            name="JobTitle"
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              placeholder="Add your job title..."
              type={"input"}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Email address<a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            rules={[
              // { required: true, message: "Missing email" },
              {
                validator: (_, value) => {
                  if (
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("Missing valid email"));
                  }
                },
              },
            ]}
            name={"EmailAddress"}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              type={"input"}
              placeholder="Add your email address..."
              disabled={true}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            City, state <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            rules={[
              { required: true, message: "Missing city, state" },
            ]}
              name={"cityState"}
              className={`city-div ${buttonTxt !== "Save" && `city-block`}`}
              style={{ width: "100%", marginTop: "2%" }}
            >
              <Select
                  placeholder="Add your city name & state name..."
                  onSearch={debounce((val) => setCityState(val))}
                  showSearch
                  showArrow={false}
                  size="large"
                  onChange={getlocationData}
                  onSelect={setLocationObject}
                >
                  {location?.map((loc) => {
                    return (
                      <Option key={loc.CityId} 
                      value={JSON.stringify(loc)}
                      >
                        {loc.Location}
                      </Option>
                    );
                  })}
                </Select>
          </Form.Item>  

          <strong style={{ fontSize: "16px" }}>
            Phone number <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            rules={[
              { required: true, message: "Add your mobile number" },
              {
                validator: (_, value) => {
                  const phoneDigits = String(value || "").replace(/\D/g, "");

                  return phoneDigits.length === 10
                    ? Promise.resolve()
                    : Promise.reject(new Error("Please enter valid mobile number"));
                },
              },
            ]}
            name={"MobilePhone"}
            style={{ width: "100%", marginTop: "2%"}}
          >
            <NumericInput
                flagselection={flagselection}
                value={MobilePhone}
                onChange={setPhoneNumber}
                changesflag={setFlagToUpdate}
                setcustomMessage={setcustomMessage}
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Address line 1 <a style={{ color: "#DB2828" }}>*</a>
            
          </strong>
          <Form.Item
            rules={[
              {
                validator: (_, value) => {
                  if (!value.trim() == "") {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("Add your address"));
                  }
                },
              },
            ]}
            name={"AddressLine1"}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              type={"input"}
              placeholder="Add your address..."
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>Address line 2</strong>
          <Form.Item
            name={"AddressLine2"}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              type={"input"}
              placeholder="Add your address..."
            />
          </Form.Item>

          <strong style={{ fontSize: "16px" }}>
            Zip code <a style={{ color: "#DB2828" }}>*</a>
          </strong>
          <Form.Item
            rules={[
              { required: true, message: "Add your zip code" },
            ]}
            name={"ZipCode"}
            style={{ width: "100%", marginTop: "2%" }}
          >
            <Input
              className="myprofile-form-input"
              type={"input"}
              placeholder="Add your zip code..."
            />
          </Form.Item>
        </div>
        {buttonTxt === "Save" &&
          <div className="Btn-Div">
          <Form.Item>
            <div className={flag && "btn-div-display"}>
              {flag ? (
                <button
                  type="button"
                  className={"myProfile-details-btn"}
                  onClick={() => {
                    setButtonTxt("Edit");
                    setFlag(false);
                    setEditDone(true);
                    setOnlyCancel(false);
                    form.setFieldsValue(defaultValues);
                    setPhoneNumber(defaultValues.MobilePhone || "");
                    setLocationValue(userProfile1?.Profiles?.Location
                      ? userProfile1.Profiles.Location
                      : cpResp?.companyProfile?.Location ?? "");
                    setflagcode(userProfile1?.Profiles?.Location?.CountryName
                      ? getFullStateName(userProfile1.Profiles.Location.CountryName)
                      : "US");
                    setCountryCodeValue(userProfile1?.Profiles?.Location?.CountryName
                      ? getCountryPhoneCode(userProfile1.Profiles.Location.CountryName)
                      : "1");
                    setIsFormRendered(false);
                    setTimeout(() => setIsFormRendered(true), 0);
                  }}
                >
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      alignItems: "left",
                    }}
                  >
                    {buttonCancelTxt}
                  </div>
                </button>
              ) : null}

              {buttonTxt === "Save" && (
                <button type="submit" className={"myProfile-details-btn-Save"}>
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>
                    {loading ? <LoadingOutlined /> : buttonTxt}
                  </div>
                </button>
              )}
            </div>
          </Form.Item>
        </div>}
        {buttonTxt === "Edit" && (
          <button
            type="button"
            className={"myProfile-details-btn myProfile-edit-profile-btn"}
            aria-label="Edit profile"
            title="Edit profile"
            onClick={() => {
              setButtonTxt("Save");
              setFlag(!flag);
            }}
          >
            <div style={{ fontWeight: "600", fontSize: "18px" }}>
              {loading ? (
                <LoadingOutlined />
              ) : (
                <>
                  <EditOutlined className="myProfile-edit-profile-icon" />
                  <span className="myProfile-edit-profile-label">{buttonTxt}</span>
                </>
              )}
            </div>
          </button>
        )}
      </Form>
      )}
    </div>
  );
};

export default MyPersonalDetails;
